import type { BuildLanguagesListsParams, BuildLanguagesListsReturnValue } from "./buildLanguagesLists.d";

const buildLanguagesLists = (
  languages: BuildLanguagesListsParams["languages"],
  pageName: BuildLanguagesListsParams["pageName"],
  cmsLanguagesData: BuildLanguagesListsParams["cmsLanguagesData"],
  getPageUrl: BuildLanguagesListsParams["getPageUrl"]
): BuildLanguagesListsReturnValue => {
  const suggestedLanguages = [];
  const selectLanguages = [];

  [...languages.entries()].map(([key, { name, languageFlag, popularLanguage, hidden }]) => {
    let localizedPagePath = "";

    if (cmsLanguagesData && cmsLanguagesData.length) {
      const cmsPageData = cmsLanguagesData.filter((item) => item.full_slug.split("/")[0] === key);
      localizedPagePath = cmsPageData[0] ? `/${cmsPageData[0].full_slug}` : `/${key}/`;
    } else {
      localizedPagePath = getPageUrl(key, pageName);
    }

    if (hidden) return {};

    const lang = {
      id: key,
      name,
      icon: languageFlag,
      href: localizedPagePath,
    };

    return popularLanguage ? suggestedLanguages.push(lang) : selectLanguages.push(lang);
  });

  return {
    suggestedLanguages,
    selectLanguages,
  };
};

export default buildLanguagesLists;
